import styles from "./About.module.scss";
import TitleUpdater from "../../../components/common/title/TitleUpdater";
import { useTranslation } from "react-i18next";

const About = () => {
  const { t } = useTranslation("translation");

  return (
    <div className={styles.about}>
      <TitleUpdater title={t("about_title")} />

      <div className="container">
        <div className={styles.about_hero}>
          <div className={styles.hero_content}>
            <div className={styles.title_badge}>{t("about_title")}</div>
            <p className={styles.hero_text}>{t("info_text")}</p>
            <p className={styles.hero_text}>{t("info_text2")}</p>
          </div>
          <div className={styles.hero_image}>
            <img
              src="https://images.unsplash.com/photo-1522071820081-009f0129c71c?w=800&h=600&fit=crop"
              alt="LuxMart Team"
            />
          </div>
        </div>

        <div className={styles.about_content}>
          <h2 className={styles.section_title}>{t("section_title")}</h2>

          <div className={styles.sections_grid}>
            <div className={styles.about_section}>
              <h3>
                <svg
                  viewBox="0 0 24 24"
                  fill="none"
                  stroke="currentColor"
                  strokeWidth="2"
                >
                  <path d="M12 2L2 7l10 5 10-5-10-5z" />
                  <path d="M2 17l10 5 10-5M2 12l10 5 10-5" />
                </svg>
                {t("section_title")}
              </h3>
              <p>{t("section_title1")}</p>
            </div>

            <div className={styles.about_section}>
              <h3>
                <svg
                  viewBox="0 0 24 24"
                  fill="none"
                  stroke="currentColor"
                  strokeWidth="2"
                >
                  <path d="M13 2L3 14h9l-1 8 10-12h-9l1-8z" />
                </svg>
                {t("do_it_title")}
              </h3>
              <p>{t("do_it_title1")}</p>
            </div>

            <div className={styles.about_section}>
              <h3>
                <svg
                  viewBox="0 0 24 24"
                  fill="none"
                  stroke="currentColor"
                  strokeWidth="2"
                >
                  <circle cx="12" cy="12" r="10" />
                  <polyline points="12 6 12 12 16 14" />
                </svg>
                {t("feel_title")}
              </h3>
              <p>{t("feel_title1")}</p>
            </div>

            <div className={styles.about_section}>
              <h3>
                <svg
                  viewBox="0 0 24 24"
                  fill="none"
                  stroke="currentColor"
                  strokeWidth="2"
                >
                  <path d="M20.84 4.61a5.5 5.5 0 0 0-7.78 0L12 5.67l-1.06-1.06a5.5 5.5 0 0 0-7.78 7.78l1.06 1.06L12 21.23l7.78-7.78 1.06-1.06a5.5 5.5 0 0 0 0-7.78z" />
                </svg>
                {t("promise_title")}
              </h3>
              <p>{t("promise_text1")}</p>
            </div>
          </div>
        </div>
      </div>

      <div className={styles.features_section}>
        <div className="container">
          <h2 className={styles.features_title}>{t("why_choose_us")}</h2>
          <div className={styles.features_grid}>
            <div className={styles.feature_card}>
              <div className={styles.feature_icon}>
                <svg
                  viewBox="0 0 24 24"
                  fill="none"
                  stroke="currentColor"
                  strokeWidth="2"
                >
                  <path d="M1 1h16l4 4-8 10-8-10 4-4z" />
                  <path d="M9 22V12" />
                  <path d="M5 18h8" />
                </svg>
              </div>
              <h4 className={styles.feature_title}>{t("free_delivery")}</h4>
              <p className={styles.feature_text}>{t("free_delivery_text")}</p>
            </div>

            <div className={styles.feature_card}>
              <div className={styles.feature_icon}>
                <svg
                  viewBox="0 0 24 24"
                  fill="none"
                  stroke="currentColor"
                  strokeWidth="2"
                >
                  <rect x="2" y="5" width="20" height="14" rx="2" />
                  <line x1="2" y1="10" x2="22" y2="10" />
                </svg>
              </div>
              <h4 className={styles.feature_title}>{t("secure_payment")}</h4>
              <p className={styles.feature_text}>{t("secure_payment_text")}</p>
            </div>

            <div className={styles.feature_card}>
              <div className={styles.feature_icon}>
                <svg
                  viewBox="0 0 24 24"
                  fill="none"
                  stroke="currentColor"
                  strokeWidth="2"
                >
                  <path d="M21 10c0 7-9 13-9 13s-9-6-9-13a9 9 0 0 1 18 0z" />
                  <circle cx="12" cy="10" r="3" />
                </svg>
              </div>
              <h4 className={styles.feature_title}>{t("postal_delivery")}</h4>
              <p className={styles.feature_text}>{t("postal_delivery_text")}</p>
            </div>

            <div className={styles.feature_card}>
              <div className={styles.feature_icon}>
                <svg
                  viewBox="0 0 24 24"
                  fill="none"
                  stroke="currentColor"
                  strokeWidth="2"
                >
                  <polyline points="9 11 12 14 22 4" />
                  <path d="M21 12v7a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h11" />
                </svg>
              </div>
              <h4 className={styles.feature_title}>{t("return_14days")}</h4>
              <p className={styles.feature_text}>{t("return_14days_text")}</p>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default About;
